import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows,faAndroid,faHtml5 } from '@fortawesome/free-brands-svg-icons';
const cardImage = require.context('../img/cards', false, /\.(png|jpe?g|webp|svg)$/);


function CardGame({ image, name, platforms }) {
  const getCardsSrc = (fileName) => {
    if (!fileName) return null;
    try {
      return cardImage(`./${fileName}`);
    } catch (err) {
      return `${process.env.PUBLIC_URL}/img/cards/${fileName}`;
    }
  };
  const src = getCardsSrc(image);

  return (
    <Card>
      <Card.Img variant="top" src={src} />
      <Card.Body>
        <Card.Title>{name}</Card.Title>
        <Card.Text>
          <PlatfommIcons platforms={platforms} />
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

function PlatfommIcons({ platforms }) {
  return (
    <span>
      {platforms?.includes('windows') && <FontAwesomeIcon icon={faWindows} />}
      {platforms?.includes('android') && <FontAwesomeIcon icon={faAndroid} />}
      {platforms?.includes('html5') && <FontAwesomeIcon icon={faHtml5} />}
    </span>

  );
}

export default CardGame;